export default class Modale {
  constructor(element) {
    this.element = element;
    this.init();   
  }

  init() {    
    // Modale interets
    const cards = this.element.querySelectorAll('.interets_cards');
    for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        card.addEventListener('click', this.openInfo.bind(this));
    }
    
   this.element.addEventListener('click', this.openAccordeon.bind(this));
  }

  openInfo(element){
    if(element.currentTarget.classList.contains('info_ouvert')){
      element.currentTarget.classList.remove('info_ouvert');
    }
    else{
      element.currentTarget.classList.add('info_ouvert');
    }
  }

  openAccordeon(element){
    const accordeonLiens = document.querySelector('.accordeon_liens');
    if(element.currentTarget.classList.contains('acco_ouverts')){
      element.currentTarget.classList.remove('acco_ouverts');
      accordeonLiens.classList.remove('liens_ouverts');
    }
    else{
      element.currentTarget.classList.add('acco_ouverts');
      accordeonLiens.classList.add('liens_ouverts');
    }
  }
}